<template>
  <div v-if="data" :class="$style.infoPageTitleBlock" :data-theme="theme">
    <h1 :class="$style.infoPageTitle">
      <img
        v-if="route.params.pageId === 'tournaments'"
        :class="$style.infoPageIcon"
        src="/images/common/cupTitle.png"
        alt="cupTitle"
      />
      {{ data.title }}
    </h1>
  </div>
</template>

<script lang="ts" setup>
import type { ComponentInfoPageBlocksTitleBlock } from '~/types/infoPages';

const props = defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksTitleBlock>,
    required: true,
  },
});

const route = useRoute();

const theme = computed(() => {
  return props.data.theme ?? 'standart';
});
</script>

<style lang="scss" module src="./titleBlock.scss"></style>
